// Page surface for the keyword monitoring dashboard.
// Slightly darker than white so the white cards read as elevated surfaces.
export const KEYWORD_DASHBOARD_PAGE_BG = "#f6f7f9"

// Routes that use the darker page surface (applied by _app to the layout shell)
export const KEYWORD_DASHBOARD_ROUTES = [
  "/threads/keyword/dashboard",
  "/threads/keyword/detail",
]

// Segmented control. The default `bg-muted` (#f5f5f5) is within a hair of the
// page background, so the track needs its own darker value to stay visible.
export const SEGMENT_LIST_CLASS =
  "h-auto gap-1 rounded-[10px] bg-[#e2e3e8] p-1"

export const SEGMENT_TRIGGER_CLASS =
  "rounded-lg px-[18px] py-2 text-sm font-medium text-[#5f616b] transition-colors hover:text-[#1b1c21] data-[state=active]:bg-white data-[state=active]:font-semibold data-[state=active]:text-[#1b1c21] data-[state=active]:shadow-[0_1px_2px_rgba(0,0,0,0.06)]"

// Same control, tighter metrics for the date-range row
export const SEGMENT_TRIGGER_COMPACT_CLASS =
  "rounded-lg px-4 py-[7px] text-[13.5px] font-medium text-[#5f616b] transition-colors hover:text-[#1b1c21] data-[state=active]:bg-white data-[state=active]:font-bold data-[state=active]:text-[#1b1c21] data-[state=active]:shadow-[0_1px_2px_rgba(0,0,0,0.06)]"
